import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import Debug from 'debug';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GetUserDto } from '../dtos/getUserDto.type';
import { RoutesUtil } from '../util/RoutesUtil';

const debug = Debug('modeso:aumico-lib-users-fe:UsersManagmentService');

@Injectable({
    providedIn: 'root',
})
export class UsersManagementService {
    /**
     *
     * @param http the http client instance
     * @param config the configurations for the library
     */
    constructor(
        private readonly http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly routesUtil: RoutesUtil,
    ) {}

    getAllUsers$(): Observable<GetUserDto[]> {
        const url = this.routesUtil.getAllUsersForAdmin();
        this.coreProvider.dispatchBlockingRequest('UsersFe_getAllUsers$');
        return this.http
            .get<GetUserDto[]>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_getAllUsers$')));
    }

    blockUser$(id: string): Observable<void> {
        const url = this.routesUtil.blockUser(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_blockUser$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_blockUser$')));
    }

    unblockUser$(id: string): Observable<void> {
        const url = this.routesUtil.unblockUser(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_unblock$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_unblock$')));
    }

    demoteUser$(id: string): Observable<void> {
        const url = this.routesUtil.demoteUser(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_demoteUser$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_demoteUser$')));
    }

    promoteUser$(id: string): Observable<void> {
        const url = this.routesUtil.promoteUser(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_promoteUser$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_promoteUser$')));
    }

    changeUserRole$(id: string, newRole: string): Observable<GetUserDto> {
        const url = this.routesUtil.updateUserRoleByAppAdmin(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_changeUserRole$');
        return this.http
            .patch<GetUserDto>(url, { role: newRole })
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_changeUserRole$')));
    }

    deleteUser$(id: string): Observable<void> {
        const url = this.routesUtil.deleteUser(id);
        this.coreProvider.dispatchBlockingRequest('UsersFe_deleteUser$');
        return this.http
            .delete<void>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_deleteUser$')));
    }
}
